module.exports = "dist/images/components-design-separator-control-wave-1.479a6de.png";